import { createRouter, createWebHistory } from 'vue-router'
import { LoginCallback, navigationGuard } from '@okta/okta-vue'
import HomeComponent from '@/components/Home'
// import ProfileComponent from '@/components/Profile'
// import MessagesComponent from '@/components/Messages'
// import TeamComponent from '@/components/Team'
import DevicesComponent from '@/components/Devices'
// import DeviceComponent from '@/components/Device'



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: HomeComponent
    },
    {
      path: '/login/callback',
      component: LoginCallback
    },
    {
      path: '/devices',
      component: DevicesComponent,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/device/:device',
    //   component: DeviceComponent,
    //   name: "DeviceComponent",
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/team',
    //   component: TeamComponent,
    //   meta: {
    //     requiresAuth: true
    //   }
    // }
  ]
})

router.beforeEach(navigationGuard)

export default router
